import React from "react";
import Style from "./Auth.module.scss";
import logo from "../imgs/YS-Logo-01.svg";

function Login(props) {
    return (
        <>
            <img src={logo} alt="Yesterday Stories" className={Style.logo} />
            <h3 className={Style.heading}>Log in</h3>
            <form onSubmit={props.login} className={Style.form}>
                <input name="email" type="email" placeholder="Email" required className={Style.input} />
                <input name="password" type="password" placeholder="Password" required className={Style.input} />
                <button type="submit" className={Style.button}>Login</button>
                <button type="button" onClick={props.change} className={Style.option}>Register &#62;</button>
            </form>
        </>
    );
}
export default Login;
